import { makeActionCreator } from '../../../../utilities'
import { ImmobilizationConstants } from './immobilization.constants'

export const setOption = makeActionCreator(ImmobilizationConstants.SET_OPTION, 'option')
export const setDevicesUsed = makeActionCreator(ImmobilizationConstants.SET_DEVICES_USED, 'devicesUsed')
export const setAssessment = makeActionCreator(ImmobilizationConstants.SET_ASSESSMENT, 'assessment')
export const setSite = makeActionCreator(ImmobilizationConstants.SET_SITE, 'site')
export const saveImmobilization = makeActionCreator(ImmobilizationConstants.SAVE_IMMOBILIZATION, 'data')
export const resetState = makeActionCreator(ImmobilizationConstants.RESET_STATE)
export const setAddToTimeLine = makeActionCreator(ImmobilizationConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(ImmobilizationConstants.SET_STATE, 'immobilizationState')
export const setDateTime = makeActionCreator(ImmobilizationConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(ImmobilizationConstants.SET_ASSESSED_BY, 'assessedBy')
export const onSelectImmobilizationProcedure = makeActionCreator(ImmobilizationConstants.ON_SELECT_IMMOBILIZATION)
export const setUpdateInputRows = makeActionCreator(ImmobilizationConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setDate = makeActionCreator(ImmobilizationConstants.SET_DATE, 'date')
export const setTime = makeActionCreator(ImmobilizationConstants.SET_TIME, 'time')
export const setSuccessfulAttempt = makeActionCreator(
  ImmobilizationConstants.SET_SUCCESSFUL_ATTEMPT,
  'successfulAttempt'
)
export const setAttempts = makeActionCreator(ImmobilizationConstants.SET_ATTEMPTS, 'attempts')
export const setProcedureComplications = makeActionCreator(
  ImmobilizationConstants.SET_PROCEDURE_COMPLICATIONS,
  'procedureComplications'
)
export const setResponse = makeActionCreator(ImmobilizationConstants.SET_RESPONSE, 'response')
export const setAuthorization = makeActionCreator(ImmobilizationConstants.SET_AUTHORIZATION, 'authorization')
export const setComments = makeActionCreator(ImmobilizationConstants.SET_COMMENTS, 'comments')
export const setSize = makeActionCreator(ImmobilizationConstants.SET_SIZE, 'size')
export const setRolePerforming = makeActionCreator(ImmobilizationConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  ImmobilizationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  ImmobilizationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
